import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false
  },
  colors: {
    brand: {
      50: '#fee2e2',
      100: '#fecaca',
      200: '#fca5a5',
      300: '#f87171',
      400: '#ef4444',
      500: '#d62828',
      600: '#b91c1c',
      700: '#991b1b',
      800: '#7f1d1d',
      900: '#450a0a'
    }
  },
  fonts: {
    heading: '"Overpass", "Segoe UI", Roboto, sans-serif',
    body: '"Overpass", "Segoe UI", Roboto, sans-serif'
  },
  components: {
    Button: {
      baseStyle: {
        color: 'gray.800'
      },
      variants: {
        solid: {
          bg: 'brand.500',
          color: 'white',
          _hover: { bg: 'brand.600' }
        },
        outline: {
          borderColor: 'brand.500',
          color: 'brand.500',
          _hover: { bg: 'brand.50' }
        },
        ghost: {
          color: 'gray.700',
          _hover: { bg: 'gray.100' }
        }
      }
    },
    Card: {
      baseStyle: {
        container: {
          bg: 'white',
          borderRadius: 'lg',
          boxShadow: 'sm'
        }
      }
    },
    Tooltip: {
      baseStyle: {
        bg: 'white',
        color: 'gray.700',
        '--tooltip-bg': 'colors.white',
        '--popper-arrow-bg': 'var(--tooltip-bg)',
        px: 3,
        py: 2,
        lineHeight: '1.3',
        borderRadius: 'md',
        fontSize: 'sm',
        boxShadow: 'md',
        border: '1px solid',
        borderColor: 'gray.200'
      }
    },
    Modal: {
      baseStyle: {
        dialog: { bg: 'white', color: 'gray.800' },
        header: { color: 'gray.800' },
        body: { color: 'gray.800' }
      }
    },
    Drawer: {
      baseStyle: {
        dialog: { bg: 'white', color: 'gray.800' }
      }
    },
    Menu: {
      baseStyle: {
        list: { bg: 'white', borderColor: 'gray.200', color: 'gray.800' },
        item: { bg: 'white', color: 'gray.800', _hover: { bg: 'gray.100' }, _focus: { bg: 'gray.100' } }
      }
    },
    Popover: {
      baseStyle: {
        content: { bg: 'white', color: 'gray.800', borderColor: 'gray.200' }
      }
    },
    Input: {
      variants: {
        outline: {
          field: {
            bg: 'white',
            color: 'gray.800',
            borderColor: 'gray.300',
            _hover: { borderColor: 'gray.400' },
            _focus: { borderColor: 'blue.500', boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)' },
            _placeholder: { color: 'gray.400' }
          }
        }
      },
      defaultProps: { variant: 'outline' }
    },
    Select: {
      variants: {
        outline: {
          field: {
            bg: 'white',
            color: 'gray.800',
            borderColor: 'gray.300',
            _hover: { borderColor: 'gray.400' },
            _focus: { borderColor: 'blue.500', boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)' }
          }
        }
      },
      defaultProps: { variant: 'outline' }
    },
    NumberInput: {
      variants: {
        outline: {
          field: {
            bg: 'white',
            color: 'gray.800',
            borderColor: 'gray.300',
            _hover: { borderColor: 'gray.400' },
            _focus: { borderColor: 'blue.500', boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)' }
          }
        }
      },
      defaultProps: { variant: 'outline' }
    },
    Tabs: {
      baseStyle: {
        tab: { color: 'gray.600', _selected: { color: 'red.600' } },
        tabpanel: { color: 'gray.800' }
      }
    },
    Table: {
      baseStyle: {
        th: { color: 'gray.600' },
        td: { color: 'gray.800' }
      }
    },
    FormLabel: {
      baseStyle: {
        color: 'gray.700'
      }
    }
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        color: 'gray.800'
      },
      'option': {
        bg: 'white !important',
        color: 'gray.800 !important'
      }
    }
  }
});

export default theme;
